import React, { useEffect, useState } from "react";
import HeaderHome from "../headers/headerHome";
import * as API from "../services/API";
import EventSlider from "../components/EventSlider";
import PartnerSlider from "../components/PartnerSlider";
import HomeEphemeride from "../components/HomeEphemerideSky";
import HomeEventsPreview from "../components/HomeEventsPreview";
import Footer from "../components/Footer";
import "../css/Home.css";

function Home() {
  const [activityList, setActivityList] = useState([]);
  const [partenaireList, setPartenaireList] = useState([]);
  const [ephemeride, setEphemeride] = useState(null);
  const [incomingEvents, setIncomingEvents] = useState([]);
  const [externalEvents, setExternalEvents] = useState([]);

  useEffect(() => {
    API.getEvenementHomeRequest(
      (response) => {
        setActivityList(response.data);
      },
      () => {}
    );
    API.getPartenairesRequest(
      (response) => {
        setPartenaireList(response.data);
      },
      () => {}
    );
    API.getEphemeride(
      (response) => {
        setEphemeride(response.data);
      },
      () => {}
    );
    API.getLastIncomingEvents(
      (response) => setIncomingEvents(response.data),
      () => {}
    );

    API.getLastExternalEvents(
      (response) => setExternalEvents(response.data),
      () => {}
    );
  }, []);

  return (
    <>
      <HeaderHome />
      <main className="home-container">
        <section className="home-introduction">
          <h1>Loisirs et Solidarité des Retraités du Lot-et-Garonne</h1>
          <p>
            LSR47 est l'association Loisirs et Solidarité des Retraités du
            Lot-et-Garonne. Elle propose aux retraités du département des
            sorties, voyages, rencontres, activités culturelles et moments de
            convivialité.
          </p>
        </section>

        <EventSlider activities={activityList} />

        <div className="home-middle-section">
          <HomeEphemeride ephemeride={ephemeride} />
          <HomeEventsPreview
            incomingEvents={incomingEvents}
            externalEvents={externalEvents}
          />
        </div>

        <PartnerSlider partners={partenaireList} />
      </main>
      <Footer />
    </>
  );
}

export default Home;
